module.exports = __webpack_public_path__ + "static/media/faber.e7fb1e6e.png";